import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guide-google-service-account',
  templateUrl: './guide-google-service-account.component.html',
  styleUrls: ['./guide-google-service-account.component.scss']
})
export class GuideGoogleServiceAccountComponent implements OnInit {

  permissions = 'https://www.googleapis.com/auth/admin.directory.resource.calendar,https://www.googleapis.com/auth/calendar.events,https://www.googleapis.com/auth/admin.directory.domain.readonly,https://www.googleapis.com/auth/admin.directory.user.readonly';
  permissions2 = 'https://www.googleapis.com/auth/calendar.readonly';
  hasCopied = false;
  hasCopied2 = false;

  constructor() { }

  ngOnInit() {
  }

  copyCredentials = (event:any) => {
    if(event && event.preventDefault) {
      event.preventDefault();
    }
    try {
      navigator.clipboard.writeText(this.permissions);
      this.hasCopied = true;
      setTimeout(() => this.hasCopied = false, 2000);
    }
    catch(error) {

    }
  }

  copyCredentials2 = (event:any) => {
    if(event && event.preventDefault) {
      event.preventDefault();
    }
    try {
      navigator.clipboard.writeText(this.permissions2);
      this.hasCopied2 = true;
      setTimeout(() => this.hasCopied2 = false, 2000);
    }
    catch(error) {

    }
  }

}
